<template>
  <div class="party">
    <template v-if="isSigner">
      <div class="party__is-signer">
        {{ $t('parties.signer') }}
      </div>
    </template>
    <div class="party__icon">
      <icon name="user" height="38" width="38"></icon>
    </div>
    <div class="party__info">
      <div :class="`party__info__header ${hideEmail ? 'party__info__header--large' : ''}`">{{ name }}</div>
      <div class="party__info__subheader" v-if="!hideEmail">{{ email }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'parties',
  props: ['name', 'email', 'isSigner'],
  data () {
    return {
      hideEmail: parseInt(this.$store.getters.config('company_hide_email_pdf_audit'), 10)
    }
  }
}
</script>

<style lang="sass" scoped>
  @import '@/styles/component-utils.sass'
  .party
    position: relative
    background-color: #fff
    color: initial
    display: block
    margin-top: $spacing-large
    border-radius: 3px
    color: #444
    @include clearfix
    &:first-child
      margin-top: 0
    &__icon
      line-height: 0
      float: left
    &__info
      float: left
      &__header
        &--large
          font-size: $font-size-medium
          margin-top: $spacing-small
      &__subheader
        font-size: $font-size-small
        font-weight: bold
        letter-spacing: 2px
        margin-top: $spacing-xs
        color: #999
    &__is-signer
      position: absolute
      right: 0
      top: 0
      background-color: #2ecc71
      padding: $spacing-xs 8px $spacing-xs $spacing-small
      font-size: 9px
      text-transform: uppercase
      color: #fff
      border-radius: 30px
      letter-spacing: 2px
      font-weight: bold
  @media screen and (max-width: $screen-size-large)
    .party
      padding: $spacing-small
      &__icon
        display: none
</style>
